<template>
  <!-- Counter Section Start -->
  <section id="counter" v-if="dataAreLoaded">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="counting">
            <div class="icon">
              <i class="ti-briefcase"></i>
            </div>
            <div class="desc">
              <h2>Offres</h2>
              <h1 class="counter">{{ jobOffersCount }}</h1>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="counting">
            <div class="icon">
              <i class="ti-user"></i>
            </div>
            <div class="desc">
              <h2>Membres</h2>
              <h1 class="counter">{{ membersCount }}</h1>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="counting">
            <div class="icon">
              <i class="ti-write"></i>
            </div>
            <div class="desc">
              <h2>Candidatures</h2>
              <h1 class="counter">{{ applicationCount }}</h1>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="counting">
            <div class="icon">
              <i class="ti-home"></i>
            </div>
            <div class="desc">
              <h2>Entreprises</h2>
              <h1 class="counter">{{ companiesCount }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";

export default {
  name: "Counter",
  data() {
    return {
      dataAreLoaded: false,
      jobOffersCount: 0,
      membersCount: 0,
      applicationCount: 0,
      companiesCount: 0,
    };
  },
  mounted() {
    const httpClient = new HttpClient();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    httpClient
      .getItemsCount()
      .then((value) => {
        this.companiesCount = value.data.companiesCount;
        this.applicationCount = value.data.applicationCount;
        this.membersCount = value.data.membersCount;
        this.jobOffersCount = value.data.jobOffersCount;
        this.dataAreLoaded = true;
      })
      .catch(() => {
        // @todo log error
      });
  },
};
</script>

<style scoped></style>
